exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-link {\n  font-size: .75rem;\n  font-weight: 700;\n  color: #0c5c68;\n  text-decoration: none;\n  transition: all .2s ease-in-out;\n}\n.icon-link:hover {\n  color: #021316;\n}\n.icon-link--primary {\n  color: #0c5c68;\n}\n.icon-link--primary:hover {\n  color: #021316;\n}\n.icon-link--secondary {\n  color: #577b00;\n}\n.icon-link--secondary:hover {\n  color: #161f00;\n}\n.icon-link--negative {\n  color: #dc2626;\n}\n.icon-link--negative:hover {\n  color: #7f1d1d;\n}\n", ""]);

// exports
